import { useQuery } from '@tanstack/react-query'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'
import { getSelectedCustomer } from 'ClientPortal/src/context/SelectedCustomerContext'
import { WithReactQueryOptions } from 'ComponentLibrary'
import invariant from 'tiny-invariant'

export const ASSETS_QUERY_KEY = 'ASSETS'

export function useGetAsset({ assetId, ...options }: WithReactQueryOptions<{ assetId?: string }>) {
    const valuationApiClient = getValuationApiClient()
    const getAssetQuery = () => {
        invariant(assetId, 'Cannot get asset without asset id')
        return valuationApiClient.assets.getAsset({ assetId, customerId: getSelectedCustomer()?.uuid })
    }
    const { data, isPending } = useQuery({
        queryFn: getAssetQuery,
        queryKey: [ASSETS_QUERY_KEY, assetId],
        enabled: !!assetId,
        ...options,
    })

    return { asset: data, isAssetPending: isPending }
}

export function useGetAssets(options: WithReactQueryOptions = {}) {
    const valuationApiClient = getValuationApiClient()
    const getAssetQuery = () => valuationApiClient.assets.getAssets({ customerId: getSelectedCustomer()?.uuid })
    const { data, isPending } = useQuery({
        queryFn: getAssetQuery,
        queryKey: [ASSETS_QUERY_KEY],
        ...options,
    })

    return { assets: data?.assets || [], isAssetPending: isPending }
}
